import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["detectUrls", "maxLines", "color", "breakWord", "weight", "variant", "onClick", "display", "children", "margin"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { StyledTypography, StyledLink } from './style';
import { urlCheckRegex } from '../../../helpers';
var Typography = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var detectUrls = _ref.detectUrls,
    maxLines = _ref.maxLines,
    color = _ref.color,
    breakWord = _ref.breakWord,
    weight = _ref.weight,
    variant = _ref.variant,
    onClick = _ref.onClick,
    display = _ref.display,
    children = _ref.children,
    margin = _ref.margin,
    props = _objectWithoutProperties(_ref, _excluded);
  var parsedChildren = children;
  if (detectUrls && typeof children === 'string') {
    var parts = children.split(urlCheckRegex);
    for (var i = 1; i < parts.length; i += 2) {
      parts[i] = /*#__PURE__*/React.createElement(StyledLink, {
        key: i,
        href: parts[i],
        target: '_blank',
        rel: 'noreferrer'
      }, parts[i]);
    }
    parsedChildren = parts;
  }
  return /*#__PURE__*/React.createElement(StyledTypography, _objectSpread({
    ref: ref,
    weight: weight,
    variant: variant,
    maxlines: maxLines,
    onClick: onClick,
    breakWord: breakWord,
    display: display,
    color: color,
    margin: margin
  }, props), parsedChildren);
});
Typography.displayName = 'Typography';
Typography.defaultProps = {
  maxlines: undefined,
  maxLines: undefined,
  weight: 'auto',
  display: undefined,
  breakWord: false,
  detectUrls: false,
  color: '',
  margin: null,
  onClick: undefined,
  children: null
};
export default Typography;